export const CALCULATE_SCORE_MESSAGES = [
  {
    title: 'Validando tus datos personales...',
    description: 'En menos de 30 segundos podrás disfrutar del poder de Powerpay.',
  },
  {
    title: 'Verificando tu historial crediticio...',
    description: 'Un gran poder conlleva una gran responsabilidad.',
  },
  {
    title: 'Comprobando nuestro banco de datos...',
    description: 'Eso tarda un poco, pero valdrá la pena esperar.',
  },
];
